import './index.scss';
import React, { PropTypes } from 'react';
import PageLayout from '../';
import SettingSidebar from './sidebar';

const SettingPageLayout = React.createClass({
    propTypes: {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    },
    render: function() {
        const path = this.props.children && this.props.children.props.location.pathname || null;

        return <PageLayout mode="setting">
            <div className="setting-mode-inner-wrapper">
                <div className="pure-g">

                    <div className="pure-u-1-4">
                        <div className="settingsSidebar">
                            <SettingSidebar path={path} />
                        </div>
                    </div>

                    <div className="pure-u-3-4">
                        <div className="settingsContentContainer">
                            <h1>{this.props.title}</h1>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>;
    }
});

export default SettingPageLayout;



// WEBPACK FOOTER //
// ./src/components/common/PageLayout/Setting/index.jsx